import loginService from "../domain/services/login.service";

// O AuthGuard procura o caminho da rota nesta lista: sem achatar, a filha (`/crm/analytics`) nao e
// encontrada e todo mundo e barrado.
const flattenRoute = (route) => [route, ...(route.children || [])];

export const filterRoutesByRoles = (routes = {}, currentUser) => {

    if (!currentUser)
        return [];

    return Object
        .values(routes)
        .flatMap(flattenRoute)
        .filter((route) => loginService.isValidRoles(route.roles, currentUser));
}
